import Channels from './Channels.container';

export default Channels;



// WEBPACK FOOTER //
// ./src/ui/channels/index.js